module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external "Lavender"
// module id = 0
// module chunks = 0 1